import { createContext } from "react";

export const ManageModuleContext = createContext({});
